import { render, staticRenderFns } from "./202401.vue?vue&type=template&id=2f06f756&scoped=true&"
import script from "./202401.vue?vue&type=script&lang=js&"
export * from "./202401.vue?vue&type=script&lang=js&"
import style0 from "./202401.vue?vue&type=style&index=0&id=2f06f756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06f756",
  null
  
)

export default component.exports